import React, { Component, useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";

import { ShowVisibleNextGroup } from "../../actions";

export function GroupsSlimV2() {
  const dispatch = useDispatch();

  const DisplayNextGroup = useSelector((state) => state.displaynextgroup);

  const [visible, setVisible] = useState(" active");

  function ShowVisible() {
    dispatch(ShowVisibleNextGroup(true, true));
  }

  useEffect(() => {
    if (DisplayNextGroup.length != 0) {
      if (
        DisplayNextGroup.displaynextgroup === true ||
        DisplayNextGroup.displaynextgroup === "ocultar"
      ) {
        setVisible("");
      } else if (DisplayNextGroup.displaynextgroup === false) {
        setVisible(" active");
      } else {
        setVisible(" active");
      }
    }
  }, [DisplayNextGroup]);

  return (
    <div
      className={"monitoria--slim w-5" + visible}
      onClick={(event) => ShowVisible()}
    >
      <span className="monitoria--slim__tool-tip tool-tip">Exibir</span>
      <span className="monitoria--slim__icon material-icons">
        arrow_forward
      </span>
      <p className="monitoria--slim__text is-poppins is-poppins--bold">
        Monitorar
      </p>
    </div>
  );
}
